import { makeExecutableSchema, addMockFunctionsToSchema } from 'graphql-tools';

export const schemaString = `
type User {
  id: Int!
  displayName: String 
  trialStartDay: String 
}

# the schema allows the following query:
type Query {
  user(id: Int!): User
}

# this schema allows the following mutation:
`;

// Make a GraphQL schema with no resolvers
const schema = makeExecutableSchema({ typeDefs: schemaString });

// Add mocks, modifies schema in place TODO
addMockFunctionsToSchema({ schema });

export default schema;
